import type { DiffHunk } from "@/types/content-blocks";

interface Props {
  filePath: string;
  hunks: DiffHunk[];
}

export function DiffBlock({ filePath, hunks }: Props) {
  return (
    <div className="my-2 rounded-md border border-white/[0.06] overflow-hidden">
      <div className="flex items-center h-7 px-3 bg-[#151518] border-b border-white/[0.06]">
        <span className="text-[10px] font-mono text-zinc-500">{filePath}</span>
      </div>
      <div className="bg-[#0F0F11] overflow-x-auto" style={{ scrollbarWidth: "thin", scrollbarColor: "#2A2A2F transparent" }}>
        {hunks.map((hunk, hi) => (
          <div key={hi}>
            <div className="px-3 py-0.5 text-[10px] font-mono text-zinc-600 bg-blue-500/[0.05]">{hunk.header}</div>
            {hunk.lines.map((line, li) => (
              <div
                key={li}
                className={`px-3 text-[11px] font-mono leading-[1.6] ${
                  line.type === "add"
                    ? "bg-emerald-500/[0.08] text-emerald-300"
                    : line.type === "remove"
                      ? "bg-red-500/[0.08] text-red-300"
                      : "text-zinc-400"
                }`}
              >
                <span className="inline-block w-4 text-zinc-600 select-none">
                  {line.type === "add" ? "+" : line.type === "remove" ? "-" : " "}
                </span>
                {line.content}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
